import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Responsibilities from 'ps-components/Modules/AddJob/Responsibilities';
import SkillsAndCertifications from 'ps-components/Modules/AddJob/SkillsAndCertifications';
import Education from 'ps-components/Modules/AddJob/Education';
import Experience from 'ps-components/Modules/AddJob/Experience';
import Family from 'ps-components/Modules/AddJob/Family';
export default class InfoContainer extends Component {
  static propTypes = {
    addJob: PropTypes.object,
    saveJob: PropTypes.func,
    updatePayReport: PropTypes.func,
    saveJobAndUpdatePay: PropTypes.func,
    skillsByJobList: PropTypes.object,
    skillsSearch: PropTypes.func,
    certificationsSearch: PropTypes.func,
    jobCertifications: PropTypes.object,
    careerLevels: PropTypes.object,
    suggestCareer: PropTypes.object,
    saveCareerLevel: PropTypes.func,
    jobFamilies: PropTypes.object,
    suggestFamily: PropTypes.object,
    saveJobFamily: PropTypes.func,
    //props for dropzone
    onDrop: PropTypes.func,
    delayUpload: PropTypes.func,
    jobDescription: PropTypes.object,
    orgJobId: PropTypes.number,
    dragAndDropScreenText: PropTypes.string,
    editMode: PropTypes.bool,
    removeJobDescription: PropTypes.func,
    editJobTitle: PropTypes.func,
    app: PropTypes.object,
    onCutSelect: PropTypes.func,
    jobSurveyList: PropTypes.object,
    updateMatch: PropTypes.func,
    jobDetails: PropTypes.object,
    surveyDetails: PropTypes.object,
    saveProfilesAnalyzed: PropTypes.func,
    jobSurveyActions: PropTypes.func,
    loadDataCutsPanel: PropTypes.func,
    showYearsExperienceLabelUpdate: PropTypes.bool,
    quickUpdateJobDetailsAndPay: PropTypes.func,
    getFileRejectReason: PropTypes.func,
    resetFileRejectReason: PropTypes.func,
    rejectReason: PropTypes.string,
    acceptedFileTypes: PropTypes.array,
    itemToUpload: PropTypes.string,
    isJdxEnabled: PropTypes.bool
  };

  constructor(props) {
    super(props);
  }

  render() {
    const {
      app,
      addJob,
      saveJob,
      updatePayReport,
      saveJobAndUpdatePay,
      skillsByJobList,
      skillsSearch,
      certificationsSearch,
      jobCertifications,
      careerLevels,
      suggestCareer,
      saveCareerLevel,
      jobFamilies,
      suggestFamily,
      saveJobFamily,
      editMode,
      jobSurveyList,
      jobDetails,
      surveyDetails,
      onCutSelect,
      updateMatch,
      orgJobId,
      saveProfilesAnalyzed,
      loadDataCutsPanel,
      showYearsExperienceLabelUpdate,
      quickUpdateJobDetailsAndPay,
      getFileRejectReason,
      resetFileRejectReason,
      rejectReason,
      acceptedFileTypes,
      itemToUpload,
      isJdxEnabled
    } = this.props;

    let yearsExperienceReport = [];
    let family = '';
    let experience = '';
    let education = '';
    let responsibilities = '';
    let skillsAndCertifications = '';
    const isMP = window.app.basicProductName === 'MarketPay';

    if (
      addJob.reports &&
      addJob.reports.yearsExperienceReport &&
      addJob.reports.yearsExperienceReport.report &&
      addJob.reports.yearsExperienceReport.report.results
    ) {
      yearsExperienceReport = addJob.reports.yearsExperienceReport.report.results;
    }

    if (addJob.formSections) {
      if (addJob.formSections.family && addJob.formSections.family.display && jobFamilies && suggestFamily) {
        family = (
          <Family
            app={app}
            jobFamily={addJob.jobFamily}
            jobFamilies={jobFamilies.items}
            suggestFamily={suggestFamily.items}
            saveJobFamily={saveJobFamily}
            internalJobTitle={this.props.addJob.orgJobTitle}
            saveJob={saveJob}
            workLocationExact={addJob.workLocationExact}
            jobCode={addJob.jobCode}
            display={addJob.formSections.family.display}
            removeJobDescription={this.props.removeJobDescription}
            showDropZoneUploading={this.props.addJob.showDropZoneUploading}
            dzFile={this.props.addJob.dzFile}
            onDrop={this.props.onDrop}
            delayUpload={this.props.delayUpload}
            orgJobId={this.props.addJob.orgJobId}
            jobDescription={this.props.addJob.jobDescription}
            jobDescriptionSuccess={this.props.addJob.jobDescriptionSuccess}
            delayFile={this.props.addJob.delayFile}
            getFileRejectReason={getFileRejectReason}
            resetFileRejectReason={resetFileRejectReason}
            rejectReason={rejectReason}
            acceptedFileTypes={acceptedFileTypes}
            itemToUpload={itemToUpload}
            isJdxEnabled={isJdxEnabled}
          />
        );
      }

      if (addJob.formSections.experience && addJob.formSections.experience.display && addJob.jobDetails) {
        experience = (
          <Experience
            careerLevels={careerLevels.items}
            suggestCareer={suggestCareer.items}
            saveCareerLevel={saveCareerLevel}
            saveJobAndUpdatePay={saveJobAndUpdatePay}
            display={addJob.formSections.experience.display}
            yearsExperience={addJob.jobDetails.YearsExperience}
            yearsMinimum={addJob.jobDetails.YearsMinimum}
            careerLevel={addJob.careerLevel}
            orgJobTitle={addJob.orgJobTitle}
            jobCode={addJob.jobCode}
            workLocationExact={addJob.workLocationExact}
            orgJobId={addJob.orgJobId}
            yearsExperienceReport={yearsExperienceReport}
            showYearsExperienceLabelUpdate={showYearsExperienceLabelUpdate}
          />
        );
      }

      if (addJob.formSections.education && addJob.formSections.education.display && addJob.jobDetails) {
        education = (
          <Education
            saveJobAndUpdatePay={saveJobAndUpdatePay}
            display={addJob.formSections.education.display}
            highestDegreeEarned={addJob.jobDetails.HighestDegreeEarned}
            majorSpecialty={addJob.jobDetails.MajorSpecialty}
            orgJobTitle={addJob.orgJobTitle}
            jobCode={addJob.jobCode}
            workLocationExact={addJob.workLocationExact}
            orgJobId={addJob.orgJobId}
            highestDegreeEarnedList={addJob.HighestDegreeEarnedList}
          />
        );
      }

      if (
        addJob.formSections.responsibilities &&
        addJob.formSections.responsibilities.display &&
        addJob.jobDetails &&
        addJob.reports
      ) {
        // sometimes management role comes in as true or false or yes or no
        // consolidate them here
        let managementRole = false;
        if (addJob && addJob.jobDetails && addJob.jobDetails.ManagementRole === 'Yes') {
          managementRole = true;
        }
        responsibilities = (
          <Responsibilities
            addJobDetails={addJob.jobDetails}
            JobResponsibilities={addJob.jobDetails.JobResponsibilities}
            ManagementRole={managementRole}
            NumberSupervised={addJob.jobDetails.NumberSupervised}
            PeopleTypesManaged={addJob.jobDetails.PeopleTypesManaged}
            hireEmployees={addJob.jobDetails.hireEmployees}
            promoteEmployees={addJob.jobDetails.promoteEmployees}
            terminateEmployees={addJob.jobDetails.terminateEmployees}
            setPay={addJob.jobDetails.setPay}
            mentorAndAdvise={addJob.jobDetails.mentorAndAdvise}
            assignEvaluateWork={addJob.jobDetails.assignEvaluateWork}
            reviewPerformance={addJob.jobDetails.reviewPerformance}
            orgJobTitle={addJob.orgJobTitle}
            orgJobCode={addJob.orgJobCode}
            workLocation={addJob.workLocation}
            orgJobId={addJob.orgJobId}
            jobCode={addJob.jobCode}
            workLocationExact={addJob.workLocationExact}
            reports={addJob.reports}
            saveJob={saveJob}
            updatePayReport={updatePayReport}
            saveJobAndUpdatePay={saveJobAndUpdatePay}
            quickUpdateJobDetailsAndPay={quickUpdateJobDetailsAndPay}
            display={addJob.formSections.responsibilities.display}
            isMP={isMP}
          />
        );
      }

      if (addJob.formSections.skillsByJob && addJob.formSections.skillsByJob.display) {
        skillsAndCertifications = (
          <SkillsAndCertifications
            addJob={addJob}
            skillsByJobList={skillsByJobList}
            skillsSearch={skillsSearch}
            certificationsSearch={certificationsSearch}
            jobCertifications={jobCertifications}
            saveJob={saveJob}
            updatePayReport={updatePayReport}
            saveJobAndUpdatePay={saveJobAndUpdatePay}
            display={addJob.formSections.skillsByJob.display}
            quickUpdateJobDetailsAndPay={quickUpdateJobDetailsAndPay}
            isMP={isMP}
          />
        );
      }
    }

    return (
      <div className="info-container">
        {addJob.jobDetails && addJob.formSections && addJob.formSections.family && addJob.formSections.family.display && (
          <div className="info-container__compensable-factors">
            <span className="compensable-factors__title">Compensable Factors:</span>
          </div>
        )}
        {family}
        {experience}
        {education}
        {responsibilities}
        {skillsAndCertifications}
      </div>
    );
  }
}
